export function getFormGeneratorInfoForPath(pathname: string): string[] {
  if (pathname.startsWith('/qaqc')) return ['qaqc_form_definitions', 'QAQC Form Generator'];
  if (pathname.startsWith('/it')) return ['it_form_definitions', 'IT Form Generator'];
  if (pathname.startsWith('/to')) return ['to_form_definitions', 'TO Form Generator'];
  if (pathname.startsWith('/hse')) return ['hse_form_definitions', 'HSE Form Generator'];
  if (pathname.startsWith('/admin')) return ['adm_form_definitions', 'Admin Form Generator'];
  if (pathname.startsWith('/construction')) return ['const_form_definitions', 'Construction Form Generator'];
  if (pathname.startsWith('/material')) return ['mat_form_definitions', 'Material Control Form Generator'];
  if (pathname.startsWith('/machinery')) return ['mach_form_definitions', 'Machinery Form Generator'];
  if (pathname.startsWith('/dcc')) return ['dcc_form_definitions', 'DCC Form Generator'];
  if (pathname.startsWith('/official')) return ['off_form_definitions', 'Official Affairs Form Generator'];
  if (pathname.startsWith('/design')) return ['dsgn_form_definitions', 'Design & Engineering Form Generator'];
  return ['', 'PDF Form Generator'];
}

export function getBaseRoute(path: string): string {
  const match = path.match(/^\/(\w+)/);
  return match ? `/${match[1]}` : '/';
}

export function getInputValue(val: unknown, fallback: string | number = ''): string | number {
  return typeof val === 'string' || typeof val === 'number' ? val : fallback;
}